import { downloadRequest, request } from "@util/request"
import { api_v1_band_user_bands_path } from "../routes"

export async function getFollowersPaged(
  bandId: number,
  page: number,
  perPage = 40,
) {
  return request({
    queryKey: [
      "followers_paged",
      {
        path: api_v1_band_user_bands_path(bandId),
        params: { type: "followers", page, per_page: perPage },
      },
    ],
  })
}

export async function downloadFollowersCsv(bandId: number): Promise<void> {
  const blob = await downloadRequest(
    `/api/v1/bands/${bandId}/user_bands/followers_csv`,
  )
  const url = URL.createObjectURL(blob)
  const a = document.createElement("a")
  a.href = url
  a.download = `followers-${bandId}.csv`
  a.click()
  URL.revokeObjectURL(url)
}

export async function downloadShowsCsv(bandId: number): Promise<void> {
  const token = localStorage.getItem("jwt_token")
  const csrfMeta = document.querySelector("meta[name=csrf-token]")
  const csrf =
    csrfMeta instanceof HTMLMetaElement ? csrfMeta.content : null

  const headers = new Headers()
  if (csrf) headers.set("X-CSRF-Token", csrf)
  if (token) headers.set("Authorization", `Bearer ${token}`)

  const response = await fetch(
    `/api/v1/bands/${bandId}/concerts_csv`,
    { headers, credentials: "same-origin" },
  )
  if (!response.ok) throw new Error(`Request failed: ${response.status}`)

  const disposition = response.headers.get("Content-Disposition") ?? ""
  const match = disposition.match(/filename="?([^";\n]+)"?/)
  const filename = match?.[1] ?? `bandnada_shows_${bandId}.csv`

  const blob = await response.blob()
  const url = URL.createObjectURL(blob)
  const a = document.createElement("a")
  a.href = url
  a.download = filename
  a.click()
  URL.revokeObjectURL(url)
}
